import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Stack, Grid2, InputBase } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import '@material/web/chips/chip-set.js';
import '@material/web/chips/filter-chip.js';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { DataGrid } from '@mui/x-data-grid';
import Divider from '@mui/material/Divider';
import DeliveryPopUp from 'app/widgets/Documents/DeliveryPopUp';
import TextField from '@mui/material/TextField';
import { SearchOutlined } from '@mui/icons-material';
import documentServices from 'app/services/document-services';
import deliveryServices from 'app/services/delivery-services';
import CircularProgress from '@mui/material/CircularProgress';

dayjs.extend(utc);
dayjs.extend(timezone);

function createData(
  id,
  code,
  signedAcknowledgement,
  signedReception,
  regularizationStatus,
  shippingCompany,
  client,
  instructionNumber,
  requirementNumber,
  invoiceOrGuideNumber,
  deliveryDate
) {
  return {
    id,
    code,
    signedAcknowledgement,
    signedReception,
    regularizationStatus,
    shippingCompany,
    client,
    instructionNumber,
    requirementNumber,
    invoiceOrGuideNumber,
    deliveryDate,
  };
}

// Esto quizás se podría producir con un for por la info que retorna el backend
const rows = [
  createData('14175', '14175', false, false, true, 'Transportista 1', 'Cliente1', '9847935', '9847935', 'F-9847050','2022-04-17'),
  createData('14171', '14171', false, false, false, 'Transportista 2', 'Cliente2', '9847935', '9847935', 'G-11154', '2022-04-17'),
  createData('14123', '14123', false, true, false, 'Transportista 3', 'Cliente3', '9847935', '9847935', 'F-9847050', '2022-04-16'),
  createData('14118', '14118', false, false, true, 'Transportista 4', 'Cliente4', '9847935', '9847935', 'F-9847050', '2022-04-16'),

  createData('34914', '34914', false, false, false, 'Transportista 5', 'Cliente5', '9847935', '9847935', 'F-9847050', '2022-04-16'),
  
  createData('34915', '34915', false, false, true, 'Transportista 6', 'Cliente6', '9847935', '9847935', 'G-11154', '2022-04-16'),
  createData('34916', '34916', false, true, true, 'Transportista 7', 'Cliente7', '9847935', '9847935', 'G-11154', '2022-04-17'),
  createData('35015', '35015', false, false, true, 'Transportista 8', 'Cliente8', '9847935', '9847935', 'F-9847050', '2022-04-17'),
  createData('35104', '35104', false, false, false, 'Transportista 9', 'Cliente9', '9847935', '9847935', 'G-11154', '2022-04-17'),
  createData('35110', '35110', false, false, true, 'Transportista 10', 'Cliente10', '9847935', '9847935', 'F-9847050', '2022-04-17'),
  createData('35111', '35111', false, false, true, 'Transportista 11', 'Cliente11', '9847935', '9847935', 'G-11154', '2022-04-17'),
  createData('35112', '35112', false, false, false, 'Transportista 12', 'Cliente12', '9847935', '9847935', 'F-9847050', '2022-04-16'),
  createData('548063456', '548063456', false, false, false, 'Transportista 13', 'Cliente13', '9847935', '9847935', 'G-11154', '2022-04-17'),
];
console.log(rows)

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  // incluir id de la delivery y enviar el id de la delivery al pop up
  {
    id: 'code',
    numeric: true,
    label: 'Entrega',
  },
  {
    id: 'signedAcknowledgement',
    numeric: true,
    label: 'Toma de conocimiento',
  },
  {
    id: 'signedReception',
    numeric: true,
    label: 'Recepción conforme',
  },
  {
    id: 'regularizationStatus',
    numeric: true,
    label: 'Regularización',
  },
  {
    id: 'shippingCompany',
    numeric: false,
    label: 'Transportista',
  },
  {
    id: 'client',
    numeric: false,
    label: 'Cliente',
  },
  {
    id: 'instructionNumber',
    numeric: true,
    label: 'Instructivo',
  },
  {
    id: 'requirementNumber',
    numeric: true,
    label: 'Pedido',
  },
  {
    id: 'invoiceOrGuideNumber',
    numeric: false,
    label: 'Factura/Guía',
  },
  {
    id: 'deliveryDate',
    numeric: false,
    label: 'Fecha entrega',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const [tableHeaders, setTableHeaders] = React.useState([]);

  React.useEffect(() => {
    // se está llamando dos veces al cargar la página
    deliveryServices.getDeliveriesDocumentsTableHeaders().then((data) => {
      setTableHeaders(data);
      console.log(data);
    }).catch((err) => {
      console.error(err);
    });
    return () => {
      setTableHeaders([]);
    };
  }, []);

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell> */}
        {tableHeaders.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Documentos
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          {/* // Este es el símbolo de filtro arriba a la derecha de la tabla */}
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function EnhancedTable({ startDate = dayjs(), endDate = dayjs(), searchQuery, regularizationFilter, signedDocsFilter, setLoading }) {
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('deliveryDate');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [deliveryPopUpIsOpen, setDeliveryPopUpIsOpen] = React.useState(false);
  const [popUpDelivery, setPopUpDelivery] = React.useState(null);
  const [deliveryPopUpOpenTab, setDeliveryPopUpOpenTab] = React.useState("signedAcknowledgement");
  const [tableData, setTableData] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading?.(true);
        const data = await deliveryServices.getDeliveriesDocumentsTableData({
          start_date: startDate.utc().startOf('day').toISOString(),
          end_date: endDate.utc().endOf('day').toISOString(),
          q: searchQuery.trim()
        });
        setTableData(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading?.(false);
      }
    };
  
    fetchData();
    return () => {
      setTableData([]);
    }
  }, [startDate, endDate, searchQuery, setLoading]);  

  const handlePopUp = (event, tab) => {
    setDeliveryPopUpOpenTab(tab);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleDeliveryPopUp = (event, tab, delivery_id) => {
    setDeliveryPopUpOpenTab(tab);
    setDeliveryPopUpIsOpen(!deliveryPopUpIsOpen);
    setPopUpDelivery(delivery_id);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(() => {
    const { pending, completed } = regularizationFilter;
    const { pendingDocs, completedDocs } = signedDocsFilter;
  
    const regularizationFilterActive = pending || completed;
    const signedDocsFilterActive = pendingDocs || completedDocs;
  
    if (!regularizationFilterActive && !signedDocsFilterActive) return [];
  
    return tableData.filter(row => {
      let matchesReg = false;
      let matchesDocs = false;
  
      // Regularización
      if (regularizationFilterActive) {
        if (pending && row.regularizationRequired) matchesReg = true;
        if (completed && row.regularizationStatus) matchesReg = true;
      }
  
      // Documentos firmados
      if (signedDocsFilterActive) {
        const isCompleted = row.signedAcknowledgement && row.signedReception;
        const isPending = !isCompleted;
        if (pendingDocs && isPending) matchesDocs = true;
        if (completedDocs && isCompleted) matchesDocs = true;
      }
  
      return matchesReg || matchesDocs;
    })
    .sort(getComparator(order, orderBy))
    .slice(
      rowsPerPage > 0 ? page * rowsPerPage : 0,
      rowsPerPage > 0 ? page * rowsPerPage + rowsPerPage : tableData.length
    );
  }, [order, orderBy, page, rowsPerPage, tableData, regularizationFilter, signedDocsFilter]);
    
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            // stickyHeader
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `row-checkbox-${index}`;
                const labelId2 = `signed-acknowledgement-checkbox-${index}`;
                const labelId3 = `content-reception-checkbox-${index}`;
                const labelId4 = `regularization-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    // onClick={(event) => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    {/* <TableCell padding="checkbox" onClick={(event) => handleClick(event, row.id)}>
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell> */}
                    <TableCell
                      // component="th"
                      id={labelId}
                      // scope="row"
                      // padding="none"
                      align='right'
                    >
                      {row.code}
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={(event) => handleDeliveryPopUp(event, "signedAcknowledgement", row.id)}
                      >
                      <Checkbox
                        className='documents-table-checkbox'
                        checked={row.signedAcknowledgement && row.unsignedAcknowledgement}
                        indeterminate={!row.signedAcknowledgement && row.unsignedAcknowledgement}
                        disabled
                        inputProps={{
                          'aria-labelledby': labelId2,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={(event) => handleDeliveryPopUp(event, "signedAcknowledgement", row.id)}
                      >
                      <Checkbox
                        className='documents-table-checkbox'
                        checked={ row.signedReception && row.unsignedReception }
                        indeterminate={ !row.signedReception && row.unsignedReception }
                        disabled
                        inputProps={{
                          'aria-labelledby': labelId3,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={(event) => {
                        row.regularizationStatus ?
                          handleDeliveryPopUp(event, "regularizationStatus", row.id)
                          : handleDeliveryPopUp(event, "signedAcknowledgement", row.id)
                        }
                      }
                      >
                      <Checkbox
                        className='documents-table-checkbox'
                        checked={row.regularizationStatus}
                        indeterminate={!row.regularizationStatus && row.regularizationRequired}
                        disabled
                        inputProps={{
                          'aria-labelledby': labelId4,
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">{row.shippingCompany}</TableCell>
                    <TableCell align="right">{row.client}</TableCell>
                    <TableCell align="right">{row.instructionNumber}</TableCell>
                    <TableCell align="right">{row.requirementNumber}</TableCell>
                    <TableCell align="right">
                      {row.invoiceOrGuideType === 'delivery-receipt' && `G - ${row.invoiceOrGuideNumber}`}
                      {row.invoiceOrGuideType === 'taxed-invoice' && `F - ${row.invoiceOrGuideNumber}`}
                      {!['delivery-receipt', 'taxed-invoice'].includes(row.invoiceOrGuideType) && row.invoiceOrGuideNumber}
                    </TableCell>
                    <TableCell align="right">{dayjs(row.deliveryDate).utc().format('DD/MM/YYYY')}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage="Filas por página"
          rowsPerPageOptions={[5, 10, 25, { value: -1, label: 'Todas' }]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <DeliveryPopUp key={"a"} delivery={popUpDelivery} handlePopUp={handlePopUp} tab={deliveryPopUpOpenTab} isOpen={deliveryPopUpIsOpen} onClose={(event) => handleDeliveryPopUp(event, "regularizationStatus", null)} onSave={handleOnSaveDeliveryPopUp} />
    </Box>
  );
}

const handleOnCloseDeliveryPopUp = () => {}
const handleOnSaveDeliveryPopUp = () => {
  console.log("handleOnSaveDeliveryPopUp() en Documents.js");
}

const Documents = () => {
  const absMinDate = dayjs('21 Jun 2023');
  const today = dayjs();
  const tenDaysAgo = dayjs().subtract(7, 'day');
  const [startDate, setStartDate] = React.useState(dayjs(tenDaysAgo));
  const [endDate, setEndDate] = React.useState(dayjs(today));
  const [inputValue, setInputValue] = React.useState('');
  const [searchQuery, setSearchQuery] = React.useState('');
  const [regularizationFilter, setRegularizationFilter] = React.useState({ pending: false, completed: false });
  const [signedDocsFilter, setSignedDocsFilter] = React.useState({ pendingDocs: true, completedDocs: true });
  const [loading, setLoading] = React.useState(true);
  const [initializedSearch, setInitializedSearch] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const searchFromURL = params.get('search_input');
    if (searchFromURL) {
      setInputValue(searchFromURL);
      setSearchQuery(searchFromURL);
    }
    setInitializedSearch(true);
    return () => {
      setInitializedSearch(false);
    }
  }, []);

  const attributesReceived = () => {
    documentServices.getAttributes(1, {
    }).then((data) => {
      // setSaving(false);
      console.log("recibí", data)
    }).catch((err) => {
      // setSaving(false);
    })
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
    attributesReceived();
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const chipPendingRef = React.useRef(null);
  const chipCompletedRef = React.useRef(null);
  const chipPendingDocsRef = React.useRef(null);
  const chipCompletedDocsRef = React.useRef(null);

  React.useEffect(() => {
    const pendingRegChip = chipPendingRef.current;
    const completedRegChip = chipCompletedRef.current;
    const pendingDocsChip = chipPendingDocsRef.current;
    const completedDocsChip = chipCompletedDocsRef.current;

    const updateFilters = () => {
        const newRegFilter = {
          pending: pendingRegChip.hasAttribute('selected'),
          completed: completedRegChip.hasAttribute('selected'),
        };

        const newDocsFilter = {
          pendingDocs: pendingDocsChip.hasAttribute('selected'),
          completedDocs: completedDocsChip.hasAttribute('selected'),
        };

        // console.log('[DEBUG] RegularizationFilter actualizado:', newRegFilter);
        // console.log('[DEBUG] SignedDocsFilter actualizado:', newDocsFilter);

        setRegularizationFilter(newRegFilter);
        setSignedDocsFilter(newDocsFilter);
    };

    updateFilters();

    const delayedUpdate = () => setTimeout(updateFilters, 0);

    pendingRegChip.addEventListener('click', delayedUpdate);
    completedRegChip.addEventListener('click', delayedUpdate);
    pendingDocsChip.addEventListener('click', delayedUpdate);
    completedDocsChip.addEventListener('click', delayedUpdate);

    return () => {
      pendingRegChip.removeEventListener('click', delayedUpdate);
      completedRegChip.removeEventListener('click', delayedUpdate);
      pendingDocsChip.removeEventListener('click', delayedUpdate);
      completedDocsChip.removeEventListener('click', delayedUpdate);
    };
  }, []);

  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={3}
        sx={{mb: 2}}>
        <Typography variant="h2">Documentos</Typography>
      </Stack>
      <Divider variant="middle"/>
      <br></br>
      <Grid2 container spacing={2} alignItems="flex-end" wrap="wrap" sx={{ overflowY: 'hidden' }}>
        <Grid2 key="delivery-date-filter">
          <Typography variant="body2" mb={1}>Fecha entrega</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              timezone='America/Santiago'
              label="Desde"
              value={startDate}
              onChange={handleStartDateChange}
              textField={(params) => <TextField {...params} />}
              minDate={absMinDate}
              maxDate={endDate}
              format="DD/MM/YY"
              slotProps={{ textField: { size: 'small', sx: { width: 130 } } }}
            />
            <DesktopDatePicker
              timezone='America/Santiago'
              label="Hasta"
              value={endDate}
              onChange={handleEndDateChange}
              textField={(params) => <TextField {...params} />}
              minDate={startDate}
              format="DD/MM/YY"
              slotProps={{ textField: { size: 'small', sx: { width: 130 } } }}
            />
          </LocalizationProvider>
        </Grid2>
        <Grid2 key="documents-filter">
          <Typography variant="body2" mb={1}>Documentos firmados</Typography>
          <md-chip-set>
          <md-filter-chip label="Pendientes" selected ref={chipPendingDocsRef}></md-filter-chip>
          <md-filter-chip label="Completados" selected ref={chipCompletedDocsRef}></md-filter-chip>
          </md-chip-set>
        </Grid2>
        <Grid2 key="regularization-filter">
          <Typography variant="body2" mb={1}>Regularizaciones</Typography>
          <md-chip-set>

            <md-filter-chip label="Por regularizar" ref={chipPendingRef}></md-filter-chip>
            <md-filter-chip label="Regularizadas" ref={chipCompletedRef}></md-filter-chip>
          </md-chip-set>
        </Grid2>
        <Grid2 sx={{ marginLeft: 'auto' }}>
        <Paper component="form" onSubmit={(e) => e.preventDefault()}  sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 280, height: 50, mr: 5 }}>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Entrega, instructivo o pedido"
              inputProps={{ 'aria-label': 'search delivery documents' }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setSearchQuery(inputValue);
                }
              }}
            />
            <IconButton
              type="button"
              sx={{ p: '10px' }}
              aria-label="search"
              onClick={() => setSearchQuery(inputValue)}
            >
              <SearchOutlined />
            </IconButton>
          </Paper>
        </Grid2>
      </Grid2>
      <br></br>
      <Divider variant="middle"/>
      <br></br>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {initializedSearch && (
        <EnhancedTable
          startDate={startDate}
          endDate={endDate}
          searchQuery={searchQuery}
          regularizationFilter={regularizationFilter}
          signedDocsFilter={signedDocsFilter}
          setLoading={setLoading}/>
      )}
      <Divider variant="middle"/>
      {/* <DataTable /> */}
    </div>
  );
};

export default Documents;
